import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createOrder, deleteOrder, fetchAllOrders,fetchUsersOrders,updateOrder } from './orderAPI';

const initialState = {
  orders: [],
  status: 'idle',
  currentOrder: null,
  userOrder:[],
  totalOrders: 0
};
//we may need more info of current order

export const createOrderAsync = createAsyncThunk(
  'order/createOrder',
  async (order) => {
    const response = await createOrder(order);
    console.log("create order res",response.data);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);
export const updateOrderAsync = createAsyncThunk(
  'order/updateOrder',
  async (order) => {
    const response = await updateOrder(order);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);
// export const deleteOrderAsync = createAsyncThunk(
//   'order/deleteOrder',
//   async (Id) => {
//     const response = await deleteOrder(Id);
//     // The value we return becomes the `fulfilled` action payload
//     return response.data;
//   }
// );

export const fetchUsersOrdersAsync = createAsyncThunk(
  'order/fetchUsersOrders',
  async () => {
    const response = await fetchUsersOrders();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const fetchAllOrdersAsync = createAsyncThunk(
  'order/fetchAllOrders',
  async ({sort, pagination}) => {
    const response = await fetchAllOrders(sort,pagination);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    resetOrder: (state) => {
      state.currentOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrderAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createOrderAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.orders.push(action.payload);

        state.currentOrder = action.payload;
        console.log('state currentOrder', state.currentOrder)

      })
      .addCase(fetchUsersOrdersAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUsersOrdersAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.userOrder = action.payload;
        console.log('order payload',state.userOrder )
      })
      .addCase(fetchAllOrdersAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllOrdersAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.orders = action.payload.orders;
        state.totalOrders = action.payload.totalOrders;
      })
      .addCase(updateOrderAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateOrderAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        const index =  state.orders.findIndex(order=>order.id===action.payload.id)
        state.orders[index] = action.payload;
      })
      // .addCase(deleteOrderAsync.pending, (state) => {
      //   state.status = "loading";
      // })
      // .addCase(deleteOrderAsync.fulfilled, (state, action) => {
      //   state.status = "idle";
      //   const index = state.orders.findIndex(
      //     (order) => order.id === action.payload.id
      //   );
      //   state.orders.splice(index, 1);
      // })
  },
});

export const { resetOrder } = orderSlice.actions;

export const selectCurrentOrder = (state) => state.order.currentOrder;
export const selectOrders = (state) => state.order.orders;
export const selectUsersOrder = (state) => state.order.userOrder;
export const selectTotalOrders = (state) => state.order.totalOrders;
export const selectStatus = (state) => state.order.status;

export default orderSlice.reducer;
